import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { QuestionnaireService } from "../services/questionnaire.service";

@Component({
  selector: 'app-financing-sources-popup',
  templateUrl: './financing-sources-popup.component.html',
  styleUrls: ['./financing-sources-popup.component.scss']
})
export class FinancingSourcesPopupComponent implements OnInit {
 @Input() public sum;
  constructor(
    public activeModal: NgbActiveModal,
    private questionnaireService: QuestionnaireService,
    private router: Router) { }

  ngOnInit(){
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  exit() {
    this.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/financing-sources-popup/financing-sources-popup.component.ts